import { useEffect } from "react"
import { useRouterState } from "@tanstack/react-router"
import { ensureSession, getSessionUser } from "@/core/auth"
import { posthog, posthogEnabled } from "@/core/posthog"

export function PostHogTracker() {
  const href = useRouterState({ select: (state) => state.location.href })

  useEffect(() => {
    if (!posthogEnabled) return
    posthog.capture("$pageview", { app: "attend-console" })
  }, [href])

  useEffect(() => {
    if (!posthogEnabled) return

    let alive = true
    const identify = (user: ReturnType<typeof getSessionUser>) => {
      if (!alive || !user) return
      // Account id only: no email or name in analytics (privacy policy, Usage Data).
      posthog.identify(user.id, {
        role: user.role ?? undefined,
        app: "attend-console",
      })
    }

    identify(getSessionUser())
    void ensureSession().then(identify).catch(() => {})

    return () => {
      alive = false
    }
  }, [])

  return null
}
